export default __webpack_public_path__ + "static/media/banner-tablet-bg-blue-template.323ef17d.svg";